import { render, staticRenderFns } from "./CertificatesList.vue?vue&type=template&id=8a4acd96&"
import script from "./CertificatesList.vue?vue&type=script&lang=js&"
export * from "./CertificatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a4acd96')) {
      api.createRecord('8a4acd96', component.options)
    } else {
      api.reload('8a4acd96', component.options)
    }
    module.hot.accept("./CertificatesList.vue?vue&type=template&id=8a4acd96&", function () {
      api.rerender('8a4acd96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/CertificatesList.vue"
export default component.exports